const study = {
  state: {
    isBuy: false,
    umcId: 0,
    defaultCid: 0,
    courseId: '',
    courseSpecialId: 0, //课程班型Id
    productId: 0,
    courseCatalog: [],
    reviewCatalog: [],
    reviewPositionName: '', //串讲名称（用于串视频提问位置）
    videoId: '',
    buyType: 0,
    catalogId: 0,
    pptId: 0,
    exerId: 0,
    userCourseList: [],
    playList: [], //播放列表（videoId[],用于连播）
    srfId: '', //学籍ID（机构教务定制专用）
  },
  mutations: {
    SET_IS_BUY: (state, isBuy) => {
      state.isBuy = isBuy;
    },
    SET_UMCID: (state, umcId) => {
      state.umcId = umcId;
    },
    SET_DEFAULTCID: (state, defaultCid) => {
      state.defaultCid = defaultCid;
    },
    SET_COURSEID: (state, courseId) => {
      state.courseId = courseId;
    },
    SET_COURSE_SPECIALID: (state, courseSpecialId) => {
      state.courseSpecialId = courseSpecialId;
    },
    SET_PRODUCTID: (state, productId) => {
      state.productId = productId;
    },
    SET_COURSE_CATALOG: (state, courseCatalog) => {
      state.courseCatalog = courseCatalog;
    },
    SET_REVIEW_CATALOG: (state, reviewCatalog) => {
      state.reviewCatalog = reviewCatalog;
    },
    SET_REVIEW_POSITION_NAME: (state, reviewPositionName) => {
      state.reviewPositionName = reviewPositionName;
    },
    SET_VIDEO_ID: (state, videoId) => {
      state.videoId = videoId;
    },
    SET_BUY_TYPE: (state, buyType) => {
      state.buyType = buyType;
    },
    SET_CATALOG_ID: (state, catalogId) => {
      state.catalogId = catalogId;
    },
    SET_PPT_ID: (state, pptId) => {
      state.pptId = pptId;
    },
    SET_EXER_ID: (state, exerId) => {
      state.exerId = exerId;
    },
    SET_USER_COURSELIST: (state, userCourseList) => {
      state.userCourseList = userCourseList;
    },
    SET_PLAY_LIST: (state, playList) => {
      state.playList = playList;
    },
    SET_SRF_ID: (state, srfId) => {
      state.srfId = srfId;
    },
  },
};

export default study;
